import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: 'remote-codex',
  name: 'ControlCenterRemoteCodex',
  meta: {
    title: '远程Codex',
    icon: 'i-ant-design:desktop-outlined',
    alwaysOpened: true,
    auth: [
      'codex-remote:user:list',
      'codex-remote:user:create',
      'codex-remote:user:update',
      'codex-remote:user:reset-password',
      'codex-remote:user:enable',
      'codex-remote:user:disable',
      'codex-remote:user:delete',
    ],
  },
  children: [
    {
      path: 'user-list',
      name: 'ControlCenterRemoteCodexUserList',
      component: () => import('@/views/control-center/remote-codex/user-list/index.vue'),
      meta: {
        title: '用户列表',
        icon: 'i-ant-design:user-outlined',
        auth: 'codex-remote:user:list',
      },
    },
  ],
}

export default routes
